<template>
    <div id="visitors">
        <div class="filter-sidebar" :class="[dropdown && 'closed']">
            <div class="filter-sidebar-content">
                <div class="filter-sidebar-group">
                    <div class="filter-sidebar-group-title">Favoriler</div>
                    <div class="filter-sidebar-group-content">
                        <div class="favorite-items">
                            <div
                                class="favorite-item"
                                v-for="fav of favFilters['page.contact-list'] || []"
                                :key="fav._id"
                                :class="{ selected: selectedFavFilter && selectedFavFilter._id === fav._id }"
                            >
                                <div class="favorite-item-content" @click="selectFavFilter(fav)">
                                    <div class="favorite-item-icon material-icons">star</div>
                                    <div class="favorite-item-text">{{ fav.name }}</div>
                                </div>
                                <SaveFilterModal
                                    :value="fav.name"
                                    @save="saveFilter($event, fav)"
                                    @delete="deleteFavFilter(fav.key, fav._id)"
                                >
                                    <template>
                                        <div class="favorite-item-edit material-icons">edit</div>
                                    </template>
                                    <template #content> sa</template>
                                </SaveFilterModal>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-sidebar-group group-filters">
                    <div class="filter-sidebar-group-title">Filters</div>
                    <div class="filter-sidebar-group-content">
                        <div class="item" v-for="(filter, index) of filteredItems">
                            <MiniFilterPreview :filter="filter" @deleteFilter="deleteFilter(index)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="filter-sidebar-footer">
                <div class="filter-sidebar-control">
                    <Filters
                        :data="filters"
                        :active="activeFilter"
                        :defaultFilters="filteredItems"
                        @changeActive="(val) => (activeFilter = val)"
                        @filtered="(items) => (filteredItems = items)"
                        align="top"
                        :view-in-side="false"
                    >
                        <template #content>
                            <div class="control-button">
                                <div class="material-icons">filter_alt</div>
                                <div>Add Filter</div>
                            </div>
                        </template>
                    </Filters>

                    <div class="control-button" v-if="filteredItems.length > 0" @click="clearFilters">
                        <div class="material-icons">filter_alt_off</div>
                        <div>Clear Filter</div>
                    </div>
                </div>
                <div class="filter-sidebar-collapse" @click="dropdown = !dropdown">
                    <div class="information-text">Show/Hide</div>
                    <div class="material-icons" style="cursor: pointer">
                        {{ dropdown ? "keyboard_double_arrow_right" : "keyboard_double_arrow_left" }}
                    </div>
                </div>
            </div>
        </div>
        <div class="visitors-content">
            <div>
                <div class="tool-head">
                    <div class="left-side">
                        <div class="save-filter-bar">
                            <div class="filter-title">
                                {{ selectedFavFilter ? selectedFavFilter.name : "Contact Search" }}
                            </div>
                            <SaveFilterModal
                                v-if="selectedFavFilter"
                                :value="selectedFavFilter.name"
                                @save="saveFilter($event, selectedFavFilter)"
                                @delete="deleteFavFilter(selectedFavFilter.key, selectedFavFilter._id)"
                            >
                                <template>
                                    <a-icon type="star" theme="filled" />
                                </template>
                                <template #content> sa</template>
                            </SaveFilterModal>
                            <SaveFilterModal @save="saveFilter" v-else>
                                <template>
                                    <a-icon type="star" />
                                </template>
                                <template #content> sa</template>
                            </SaveFilterModal>
                        </div>
                        <a-input-search
                            style="width: 100%"
                            :placeholder="$t('message.typeSTToSearch')"
                            v-model="searchText"
                            @change="onSearch"
                        ></a-input-search>
                    </div>
                    <div class="right-side">
                        <a-popover placement="bottomRight" trigger="click">
                            <template slot="content">
                                <div v-for="col of allColumns">
                                    <a-checkbox v-model="col.enabled" @change="onChangeCol(col, $event)">
                                        {{ col.title }}
                                    </a-checkbox>
                                </div>
                            </template>
                            <a-button class="flex-center-center">
                                <div class="material-icons">app_registration</div>
                            </a-button>
                        </a-popover>
                        <a-button class="flex-center-center" @click="paddingReset">
                            <div class="material-icons">{{ paddingReseted ? "fullscreen" : "fullscreen_exit" }}</div>
                        </a-button>
                        <a-popover placement="bottomRight" trigger="click">
                            <template slot="content">
                                <div class="export-csv-visitor-page" @click="exportToCSV">
                                    <div class="material-icons">description</div>
                                    {{ $t("message.exportToCSV") }}
                                </div>
                            </template>
                            <a-button class="flex-center-center" style="margin-right: 3px">
                                <div class="material-icons">more_horiz</div>
                            </a-button>
                        </a-popover>
                    </div>
                </div>
                <supsis-table
                    id="supsis-contacts-list"
                    :class="{ 'visitor-table': true, expended: paddingReseted }"
                    :columns="columns"
                    :rows="visitors"
                    :options="tableOptions"
                    :bottom-pagination="true"
                    :pagination-cursor="paginationCursor"
                    @cursor-changed="paginationCursorChanged"
                >
                    <template #emptyData>
                        <EmptyFilterResult :clear-filters="clearFilters" />
                    </template>
                </supsis-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { log2 } from "../../../utils/log2";
import Filters from "./components/Filters.vue";
import MiniFilterPreview from "./components/MiniFilterPreview.vue";
import NoData from "./components/svg/NoData.vue";
import SupsisTable from "../../../components/SupsisTable";

import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import SaveFilterModal from "./components/SaveFilterModal.vue";
import GroupCollapse from "../../../components/GroupCollapse.vue";
import StringUtils from "../../../utils/StringUtils";
import IconButton from "../Settings/components/IconButton.vue";
import _ from "lodash";
import { exportToCSV } from "../../../utils/utils";
import { getOrUpdateFilters } from "../../../utils/persistenceStorage";
import PlatformIconViewer from "../../../components/common/PlatformIconViewer.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import EmptyFilterResult from "../Chatbot/pages/archive/EmptyFilterResult.vue";

const log = log2("Visitors");

const visitorStorage = getOrUpdateFilters("visitor-filters");

export default {
    name: "Visitors",
    components: {
        IconButton,
        GroupCollapse,
        SaveFilterModal,
        WhatsappIcon,
        AppBreadCrumb,
        Filters,
        MiniFilterPreview,
        NoData,
        SupsisTable,
        PlatformIconViewer,
        EmptyFilterResult,
    },
    data() {
        return {
            dropdown: false,
            filters: [
                {
                    name: this.$t("message.name"),
                    material_icons: "person",
                    multiple: false,
                    key: "fullname",
                    operators: true,
                    inputs: [
                        {
                            key: "fullname",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.email"),
                    material_icons: "alternate_email",
                    multiple: false,
                    key: "email",
                    operators: true,
                    inputs: [
                        {
                            key: "email",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("chatbotv2.attr.platform"),
                    material_icons: "ads_click",
                    multiple: true,
                    key: "platform",
                    operators: true,
                    inputs: [
                        {
                            type: "select",
                            key: "platform",
                            multiple: true,
                            data: [
                                "web",
                                "calendar",
                                "whatsapp",
                                "instagram",
                                "telegram",
                                "email",
                                "messenger",
                                "meta-leads",
                            ].map((key) => ({
                                key,
                                value: key[0].toUpperCase() + key.slice(1),
                            })),
                        },
                    ],
                },
                {
                    name: this.$t("chatbotv2.attr.last_seen"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "lastSeen",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "lastSeen",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.firstSeen"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "firstSeen",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "firstSeen",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.country"),
                    material_icons: "location_on",
                    multiple: false,
                    key: "country",
                    operators: true,
                    inputs: [
                        {
                            key: "country",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.city"),
                    material_icons: "location_on",
                    multiple: false,
                    key: "city",
                    operators: true,
                    inputs: [
                        {
                            key: "city",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.os"),
                    material_icons: "settings_suggest",
                    multiple: false,
                    key: "os",
                    operators: true,
                    inputs: [
                        {
                            key: "os",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.connectionDate"),
                    material_icons: "date_range",
                    multiple: false,
                    key: "connectionTime",
                    inputs: [
                        {
                            name: "Date Between",
                            key: "connectionTime",
                            type: "date",
                        },
                    ],
                },
                {
                    name: this.$t("message.visitingPage"),
                    material_icons: "public",
                    multiple: false,
                    key: "visitingPage",
                    operators: true,
                    inputs: [
                        {
                            key: "visitingPage",
                            type: "text",
                        },
                    ],
                },
                {
                    name: this.$t("message.browser"),
                    material_icons: "computer",
                    multiple: false,
                    key: "browser",
                    operators: true,
                    inputs: [
                        {
                            key: "browser",
                            type: "text",
                        },
                    ],
                },
            ],
            filteredItems: (visitorStorage.selectedFavFilter?.length > 0 && visitorStorage.selectedFavFilter) ||
                (visitorStorage.filters?.length > 0 && visitorStorage.filters) || [
                    {
                        name: this.$t("chatbotv2.attr.platform"),
                        material_icons: "ads_click",
                        multiple: true,
                        key: "platform",
                        operators: true,
                        inputs: [
                            {
                                type: "select",
                                key: "platform",
                                multiple: true,
                                data: [
                                    { key: "web", value: "Web" },
                                    { key: "calendar", value: "Calendar" },
                                    { key: "whatsapp", value: "Whatsapp" },
                                    { key: "instagram", value: "Instagram" },
                                    { key: "messenger", value: "Messenger" },
                                    { key: "telegram", value: "Telegram" },
                                    { key: "meta-leads", value: "Meta Leads" },
                                    { key: "email", value: "Email" },
                                ],
                                value: ["web"],
                            },
                        ],
                        rule: "is",
                    },
                    {
                        name: this.$t("message.connectionDate"),
                        material_icons: "date_range",
                        multiple: false,
                        key: "connectionTime",
                        inputs: [
                            {
                                name: "Date Between",
                                key: "connectionTime",
                                type: "date",
                                value: null,
                                period: "today",
                            },
                        ],
                    },
                ],
            filterAccordion: true,
            activeFilter: false,
            searchText: visitorStorage.query,
            visitors: [],
            staticColumns: [
                {
                    title: this.$t("message.name"),
                    field: "fullname",
                    key: "fullname",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.fullname }}>{row.fullname}</div>;
                    },
                },
                {
                    title: this.$t("message.email"),
                    field: "email",
                    key: "email",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.email }}>{row.email}</div>;
                    },
                },
                {
                    title: this.$t("chatbotv2.attr.platform"),
                    field: "platform",
                    key: "platform",
                    width: 100,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div v-tippy={{ content: row.platform[0].toUpperCase() + row.platform.slice(1) }}>
                                <PlatformIconViewer platform={row.platform} />
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("chatbotv2.attr.last_seen"),
                    field: "_id",
                    key: "_id",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.connectionTime);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.firstSeen"),
                    field: "createdAt",
                    key: "createdAt",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.createdAt);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.country"),
                    field: "country",
                    key: "country",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.country }}>{row.country}</div>;
                    },
                },
                {
                    title: this.$t("message.city"),
                    field: "city",
                    key: "city",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.city }}>{row.city}</div>;
                    },
                },
                {
                    title: this.$t("message.os"),
                    field: "os",
                    key: "os",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.os }}>{row.os}</div>;
                    },
                },
                {
                    title: this.$t("message.connectionDate"),
                    field: "connectionTime",
                    key: "connectionTime",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const formatedDate = this.formatDate(row.connectionTime);
                        return <div v-tippy={{ content: formatedDate }}>{formatedDate}</div>;
                    },
                },
                {
                    title: this.$t("message.visitingPage"),
                    field: "visitingPage",
                    key: "visitingPage",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.visitingPage }}>{row.visitingPage}</div>;
                    },
                },
                {
                    title: this.$t("message.browser"),
                    field: "browser",
                    key: "browser",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        return <div v-tippy={{ content: row.browser }}>{row.browser}</div>;
                    },
                },
                {
                    title: "Tags",
                    field: "tags",
                    key: "tags",
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const tags = row.tags.map((tag) => ({
                            id: tag,
                            name: this.hashTags[tag] ? this.hashTags[tag].name : "Bilinmeyen",
                        }));
                        return (
                            <div v-tippy={{ content: tags.map((tag) => tag.name).join(",") }}>
                                {tags.map((tag) => {
                                    return (
                                        <a-tag color={"#22272d"} key={tag.id}>
                                            {tag.name}
                                        </a-tag>
                                    );
                                })}
                            </div>
                        );
                    },
                },
            ],
            allColumns: [],
            columns: [],
            filterTimeout: null,
            paddingReseted: false,
            tableOptions: {
                rowStyleOption: {
                    stripe: true,
                },
                borderX: true,
                borderY: true,
                scrollWidth: 1130,
                virtualScrollOptions: { itemSize: 50, height: 500 },
                eventCustomOption: {
                    bodyRowEvents: ({ row, rowIndex }) => {
                        return {
                            dblclick: (event) => {
                                if (!this.visitorDetailPermission) {
                                    this.$message.error(this.$t("permissionErrors.visitorDetailRead"));
                                } else {
                                    this.addNewWindow({
                                        type: "show-visitor",
                                        title: `${row.fullname || "Visitor"} Profile`,
                                        payload: {
                                            visitorId: row._id,
                                        },
                                    });
                                }
                            },
                        };
                    },
                },
            },
            paginationCursor: {
                page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
                perPage: this.$route.query.perPage ? parseInt(this.$route.query.perPage) : 10,
                total: 0,
            },
            selectedFavFilter: visitorStorage.selectedFavFilter,
            selectedChannel: null,
            tableLoadingInstance: null,
        };
    },
    computed: {
        ...mapState({
            visitorAttributes: (state) => state.contactProperty.data,
            tags: (state) => state.tag.tags.data,
            hashTags: (state) =>
                state.tag.tags.data.reduce((acc, tag) => {
                    acc[tag._id] = tag;
                    return acc;
                }, {}),
            users: (state) => state.user.users.data,
            segments: (state) => state.CB.segments,
            favFilters: (state) => state.favFilters.filters,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        visitorDetailPermission() {
            return [
                PERMISSION_TYPES["visitor.delete"].tr.name,
                PERMISSION_TYPES["visitor.update"].tr.name,
                PERMISSION_TYPES["visitor.block"].tr.name,
                PERMISSION_TYPES["visitor.unblock"].tr.name,
            ].some((permission) => this.checkPermission(permission));
        },
    },
    methods: {
        ...mapActions({
            getVisitorList: "visitor/getVisitorList",
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
            createFilter: "favFilters/createFilter",
            fetchFilters: "favFilters/fetchFilters",
            getFavFilters: "favFilters/getFilters",
            updateFilter: "favFilters/updateFilter",
            favFilterDelete: "favFilters/deleteFilter",
            addNewWindow: "app/addNewWindow",
        }),
        paginationCursorChanged(cursor) {
            this.paginationCursor = _.cloneDeep(cursor);
            this.getVisitors();
        },
        formatDate(date) {
            return this.$moment(date).format("LLL");
        },
        selectFavFilter(filter, force = false) {
            this.selectedFavFilter = force ? filter : filter._id !== this.selectedFavFilter?._id && filter;
            const filters = getOrUpdateFilters("visitor-filters");
            this.filteredItems = _.cloneDeep(this.selectedFavFilter?.filters || filters.filters || this.filteredItems);
        },
        saveFilter(name, item) {
            let isEqualName = false;
            if (!item) {
                item = (this.favFilters["page.contact-list"] || []).find((i) => i.name === name);
                isEqualName = true;
            }
            if (item) {
                this.updateFilter({
                    id: item._id,
                    key: "page.contact-list",
                    name,
                    filters: isEqualName ? [...this.filteredItems] : item.filters,
                }).then((filter) => {
                    if (item._id === this.selectedFavFilter?._id || isEqualName) {
                        this.selectFavFilter(filter, true);
                    }
                });
            } else {
                this.createFilter({
                    key: "page.contact-list",
                    name,
                    filters: [...this.filteredItems],
                }).then((createdItem) => {
                    this.selectFavFilter(createdItem);
                });
            }
        },
        deleteFavFilter(key, id) {
            if (id === this.selectedFavFilter?._id) {
                this.selectFavFilter(this.selectedFavFilter);
            }
            this.favFilterDelete({ key, id });
        },
        deleteFilter(index) {
            const f = this.filteredItems.find((filter, i) => i === index);
            if (f.notDeleted) return;
            this.filteredItems = this.filteredItems.filter((filter, i) => i !== index);
        },
        onChangeCol(col, e) {
            if (e.target.checked) {
                this.columns = [...this.columns, col];
            } else {
                this.columns = this.columns.filter((c) => c.key !== col.key);
            }
            localStorage.setItem("contacts-columns", JSON.stringify(this.columns));
        },
        syncColumns() {
            const columns = JSON.parse(
                localStorage.getItem("contacts-columns") || JSON.stringify(this.staticColumns.slice(0, 5))
            );

            const columnsHash = columns.reduce((acc, column) => {
                acc[column.key] = true;
                return acc;
            }, {});

            this.allColumns = [
                ...this.staticColumns.map((col) => ({
                    ...col,
                    enabled: columnsHash[col.key] || false,
                    width: 200,
                    align: "left",
                })),
                ...this.$_.cloneDeep(this.visitorAttributes).map((attr) => ({
                    title: attr.label,
                    field: `contactProperty_${attr._id}`,
                    key: `contactProperty_${attr._id}`,
                    enabled: columnsHash[`contactProperty_${attr._id}`] || false,
                    width: 200,
                    align: "left",
                    renderBodyCell: ({ row }) => {
                        const val = this.getContactPropertyValue(row, attr._id);
                        return <div v-tippy={{ content: val }}>{val}</div>;
                    },
                })),
            ];
            const hashedColumns = this.allColumns.reduce((acc, col) => {
                acc[col.key] = col;
                return acc;
            }, {});

            this.columns = columns.map((col) => hashedColumns[col.key]);
        },
        clearFilters() {
            this.filteredItems = this.filteredItems.filter((item) => item.notDeleted);
        },
        syncFilters() {
            const findPropertyFilter = this.filters.findIndex((f) => f.key === "contact_properties");
            const propertyFilter = {
                name: "Contact Properties",
                material_icons: "alternate_email",
                multiple: true,
                key: "contact_properties",
                operators: true,
                inputs: [
                    {
                        type: "select",
                        key: "contact_property",
                        multiple: false,
                        data: this.visitorAttributes.map((attr) => ({
                            key: attr._id,
                            value: attr.label,
                        })),
                    },
                    {
                        name: "Search",
                        key: "search",
                        type: "text",
                    },
                ],
            };
            if (findPropertyFilter < 0) {
                this.filters = [...this.filters, propertyFilter];
            } else {
                this.filters.splice(findPropertyFilter, 1, propertyFilter);
            }

            const findTagFilter = this.filters.findIndex((f) => f.key === "tags");
            const tagFilter = {
                name: "Tags",
                material_icons: "label",
                multiple: true,
                key: "tags",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "tags",
                        multiple: true,
                        data: this.tags.map((tag) => ({
                            key: tag._id,
                            value: tag.name,
                        })),
                    },
                ],
            };
            if (findTagFilter < 0) {
                this.filters = [...this.filters, tagFilter];
            } else {
                this.filters.splice(findTagFilter, 1, tagFilter);
            }

            const fUserFilter = this.filters.findIndex((f) => f.key === "agent_filter");
            const userFilter = {
                name: "Prefered Agents",
                material_icons: "support_agent",
                multiple: true,
                key: "agent_filter",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "preferredAgents",
                        multiple: true,
                        data: this.users.map((user) => ({
                            key: user._id,
                            value: user.name,
                        })),
                    },
                ],
            };
            if (fUserFilter < 0) {
                this.filters = [...this.filters, userFilter];
            } else {
                this.filters.splice(fUserFilter, 1, userFilter);
            }

            const fSegmentFilter = this.filters.findIndex((f) => f.key === "segment_filter");
            const segmentFilter = {
                name: "Segments",
                material_icons: "groups",
                multiple: true,
                key: "segment_filter",
                operators: true,
                disableOperators: ["starts_with", "ends_with"],
                inputs: [
                    {
                        type: "select",
                        key: "segment",
                        multiple: true,
                        data: this.segments.map((user) => ({
                            key: user._id,
                            value: user.name,
                        })),
                    },
                ],
            };
            if (fSegmentFilter < 0) {
                this.filters = [...this.filters, segmentFilter];
            } else {
                this.filters.splice(fSegmentFilter, 1, segmentFilter);
            }
        },
        getContactPropertyValue(visitor, cpId) {
            return visitor.contactProperties?.find((c) => c.property === cpId)?.value || "N/A";
        },
        paddingReset() {
            this.paddingReseted = !this.paddingReseted;
        },
        onSearch: _.debounce(function () {
            this.paginationCursor.page = 1;
            this.getVisitors();
        }, 500),
        getVisitors() {
            this.tableLoadingInstance.show();
            getOrUpdateFilters("visitor-filters", {
                filters: this.filteredItems,
                selectedFavFilter: this.selectedFavFilter,
                query: this.searchText,
            });
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    page: this.paginationCursor.page,
                    perPage: this.paginationCursor.perPage,
                },
            });
            this.getVisitorList({
                filters: this.getFilters(),
                page: this.paginationCursor.page,
                pageSize: this.paginationCursor.perPage,
                query: this.searchText,
            }).then((response) => {
                this.tableLoadingInstance.close();
                this.paginationCursor.total = response.data.total;
                this.visitors = response.data.visitors;
            });
        },
        getFilters() {
            return this.filteredItems
                .map((filter) =>
                    filter.inputs.reduce((acc, input, index) => {
                        if (
                            input.type === "date" && input.period !== "custom"
                                ? !input.period
                                : input.value === "" || input.value === null || input.value === undefined
                        )
                            return;
                        if (index === 0) {
                            acc = {
                                key: input.key,
                                rule: filter.rule,
                                input: input.period ? (input.period === "custom" ? input.value : null) : input.value,
                                period: input.period,
                            };
                        } else if (index >= 1) {
                            acc[input.key] = input.value;
                        }
                        return acc;
                    }, {})
                )
                .filter((c) => c);
        },
        exportToCSV() {
            const data = this.visitors.map((visitor) => {
                return this.columns.reduce((acc, column) => {
                    let value = visitor[column.key];
                    if (column.key === "tags") {
                        const names = visitor.tags.map((tag) =>
                            this.hashTags[tag] ? this.hashTags[tag].name : "Bilinmeyen"
                        );
                        value = names.join(",");
                    } else if (column.key === "connectionTime") {
                        value = this.formatDate(this.connectionTime);
                    } else if (column.key === "createdAt") {
                        value = this.formatDate(this.createdAt);
                    } else if (column.key === "_id") {
                        value = this.formatDate(this.connectionTime);
                    } else if (column.key.startsWith("contactProperty_")) {
                        value = this.getContactPropertyValue(visitor, column.key.split("_")[1]);
                    }
                    acc[column.title] = value;
                    return acc;
                }, {});
            });
            exportToCSV(data, `Supsis Contact List (${this.$moment().format("YYYY-MM-DD HH:MM")})`);
        },
    },
    async mounted() {
        this.tableLoadingInstance = this.$veLoading({
            target: document.querySelector("#supsis-contacts-list"),
            name: "wave",
        });
        this.syncFilters();
        this.syncColumns();
        this.getVisitors();
        this.fetchFilters("page.contact-list");
    },
    watch: {
        visitorAttributes: {
            handler() {
                this.syncColumns();
                this.syncFilters();
            },
            deep: true,
        },
        tags: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        users: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        segments: {
            handler() {
                this.syncFilters();
            },
            deep: true,
        },
        filteredItems: {
            handler() {
                if (this.filterTimeout) clearTimeout(this.filterTimeout);
                this.filterTimeout = setTimeout(() => {
                    const selectedFilters = StringUtils.hashCodeObj({ ...this.filteredItems });
                    const selectedFavFilters = StringUtils.hashCodeObj({ ...this.selectedFavFilter?.filters });
                    if (this.selectedFavFilter && selectedFilters !== selectedFavFilters) {
                        this.selectedFavFilter = null;
                    }
                    this.paginationCursor.page = 1;
                    this.getVisitors();
                }, 500);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.export-csv-visitor-page {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.notting-here {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 200px;
    }
}

#visitors {
    position: relative;
    height: 100%;
    display: flex;
    max-width: calc(100vw - 75px);

    #supsis-contacts-list {
        .ve-loading-wave-rect {
            background: #22272d !important;
        }
    }
    .visitor-table {
        .ve-table-header-tr,
        .ve-table-body-tr,
        .ve-table-header-th,
        .ve-table-body-td div {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: min-content;
        }
        &.paddingReseted {
            .ve-table-header-tr,
            .ve-table-body-tr {
                height: 0;
            }

            .ve-table-header-th,
            .ve-table-body-td {
                padding: 0;
            }
        }
    }

    .visitor-pagination {
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .flex-center-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .padding-zero {
        th,
        td {
            padding: 0;
        }
    }

    .limited-row td {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-transform: ellipsis;
        text-overflow: ellipsis;
    }

    .filter-sidebar {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
        width: 280px;
        max-width: 280px;
        border-right: 1px solid var(--color-border-default);
        position: relative;
        transition: all 0.3s;
        white-space: nowrap;
        font-family: Poppins;

        .filter-sidebar-content {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 4px;
            width: 280px;

            .filter-sidebar-group {
                border-bottom: 1px solid var(--color-border-default);
                width: 100%;
                padding: 10px;
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                gap: 6px;

                .filter-sidebar-group-title {
                    font-weight: 600;
                    font-size: 14px;
                }

                .filter-sidebar-group-content {
                    width: 100%;
                    .favorite-items {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        gap: 4px;
                        width: 100%;

                        .favorite-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 3px;
                            width: 100%;
                            padding: 5px;
                            border-radius: 4px;
                            cursor: pointer;

                            &.selected {
                                background-color: #22272d;
                                color: var(--color-text-onprimary-default);
                            }

                            &:not(&.selected) {
                                &:hover {
                                    background: var(--color-bg-neutral-hover);
                                }
                            }

                            .favorite-item-content {
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                width: 100%;
                                .favorite-item-icon {
                                    &.material-icons {
                                        font-size: 18px;
                                    }
                                    .whatsapp-icon path {
                                        fill: #0bba18;
                                    }
                                }

                                .favorite-item-text {
                                    font-size: 12px;
                                    font-weight: 600;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }

                            &:hover {
                                .favorite-item-edit {
                                    opacity: 1;
                                }
                            }

                            .favorite-item-edit {
                                border: 1px solid var(--color-border-default);
                                background: white;
                                color: black;
                                font-size: 18px;
                                font-weight: 400;
                                opacity: 0;
                                border-radius: 3px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
        .filter-sidebar-footer {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 4px;
            width: 100%;
            .filter-sidebar-control {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                border-top: 1px solid var(--color-border-default);
                width: 100%;
                padding: 10px;

                .control-button {
                    width: 100%;
                    border: 1px solid var(--color-border-default);
                    color: var(--default-text-color);
                    padding: 5px 10px;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    font-size: 14px;
                    user-select: none;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }
            .filter-sidebar-collapse {
                border-top: 1px solid var(--color-border-default);
                color: var(--default-text-color);
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                cursor: pointer;
                user-select: none;
                height: 40px;
                padding: 0 10px;
            }
        }
        &.closed {
            width: 50px !important;
            .filter-sidebar-content {
                width: 100% !important;
            }
            .filter-sidebar-collapse {
                justify-content: center !important;
            }

            .favorite-item.channel-type,
            .filter-sidebar-collapse > .information-text,
            .favorite-item-text,
            .favorite-item-edit,
            .filter-sidebar-control,
            .filter-sidebar-group-title,
            .filter-sidebar-group.group-filters {
                display: none !important;
            }
        }
    }

    .visitors-content {
        width: 100%;
        min-width: calc(100% - 280px);
        padding: 30px;
        overflow-y: auto;
        height: calc(100vh - 56px);
        overflow-x: hidden;

        .save-filter-bar {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            gap: 5px;
            white-space: nowrap;
            width: 200px;

            .filter-title {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .tool-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .left-side {
                width: 50%;
                display: flex;
                align-items: center;
                gap: 10px;
            }

            .right-side {
                display: flex;
                align-items: center;
                gap: 4px;
            }
        }

        .filter-name {
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 18px;

            &.active {
                span.material-icons {
                    color: goldenrod;
                }
            }

            span.material-icons {
                margin-left: 5px;
            }
        }
    }
}
</style>
